import { Box, Stack, styled, Typography } from "@mui/material";
import MuiTimeline from "@mui/lab/Timeline";
import { timelineItemClasses } from "@mui/lab/TimelineItem";
import { TimelineConnector } from "./TimelineItem.styles";

export const TimelineSectionHeadline = styled(Typography)({
    color: "var(--community-color-primary-text)",
    fontSize: "14px",
    fontWeight: "700",
    marginBottom: "8px",
    textAlign: "center",
});

export const LoadingStack = styled(Stack)({
    margin: "0 16px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});

export const TimelineContainer = styled(Box)({
    marginTop: "16px",
    minWidth: "300px",
});

export const Timeline = styled(MuiTimeline)({
    padding: 0,
    [`& .${timelineItemClasses.root}:before`]: {
        flex: 0,
        padding: 0,
    },
    marginBottom: "0",
});

export const PlayerAvatarContainer = styled(Box)({
    width: "28px",
    height: "36px",
    marginRight: "8px",
    overflow: "hidden",
    "@media (max-width: 375px)": {
        display: "none",
    },
});

export const IconContainer = styled(Box)({
    display: "flex",
    alignItems: "center",
    marginRight: "4px",
    "& > svg": {
        width: "14px",
        height: "14px",
    },
});

export const TimelineItemContainer = styled(Box)({
    display: "flex",
    alignItems: "center",
});

export const TimelineScore = styled(Typography)({
    background: "var(--community-color-light-steal-blue)",
    borderRadius: "4px",
    fontSize: "14px",
    fontWeight: 500,
    color: "var(--community-color-snow-white)",
    padding: "0 4px",
    marginRight: "4px",
});

export const TimelineEnd = styled(TimelineConnector)({
    height: "2px",
    width: "20px",
    flex: "none",
});

export const TimelineEndTitle = styled(Typography)({
    margin: "0 0 4px",
});

export const GameStateChangedTitle = styled(TimelineEndTitle)({
    fontSize: "14px",
    fontWeight: 700,
});

export const HalftimeTitle = styled(GameStateChangedTitle)({
    marginTop: "4px",
});
